import { render, staticRenderFns } from "./Collaboration.vue?vue&type=template&id=0affa526&"
import script from "./Collaboration.vue?vue&type=script&lang=ts&"
export * from "./Collaboration.vue?vue&type=script&lang=ts&"
import style0 from "./Collaboration.vue?vue&type=style&index=0&id=0affa526&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports